var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.popup)?_c('div',{staticClass:"landing-section"},[(_vm.popup)?_c('WizardForm',{attrs:{"popup":_vm.popup},on:{"popup-changed":_vm.popupChanged}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }